import React, { useContext, useState } from "react"
import { Button } from "react-bootstrap"

import { FermManagementConfigContext } from "../../../../config/FermManagementConfigProvider"
import AreYouSureModal from "../../../widgets/AreYouSureModal"
import StartRunModal from "./"

export default function StartEditRunButton({
  onBtnClick,
  onSuccess,
  onHide,
  isUpdate = false,
  disabled = false,
  run = {},
  type = "add",
  small = false,
  btnVariant = "outline-primary",
  flexStart = true,
  intl,
}) {
  const [runFormModal, setRunFormModal] = useState(false)
  const [verifyDuplicateModal, setVerifyDuplicateModal] = useState(false)
  const context = useContext(FermManagementConfigContext)
  const { permissions = [] } = context
  // Variables that can change based on version of button requested
  let glyph = "plus-circle",
    translation = { id: "fermmanagement.start.run", defaultMessage: "Start Run" },
    actionPermitted = permissions.includes("innoculate_fermentation_run"),
    setModal = setRunFormModal,
    labelSupp = "",
    finalRun = run,
    extraKlass = small ? "btn-extra-sm" : ""
  const needInoculationInfo = run?.id && run?.missing_parental_information,
    finalType = needInoculationInfo && type === "edit" ? "inoculate" : type
  if (finalType === "duplicate") {
    translation = { id: "fermmanagement.duplicate.run", defaultMessage: "Duplicate Run" }
    setModal = setVerifyDuplicateModal
    finalRun = {
      metadata: run?.metadata || {},
      run_description: run?.run_description || "",
      run_comment: run?.run_comment || "",
      experiments: run?.experiments || [],
    }
    labelSupp = run?.name
  } else if (finalType === "edit") {
    glyph = "pencil-square-o"
    translation = { id: "general.edit", defaultMessage: "Edit" }
    actionPermitted = permissions.includes("edit_fermentation_run")
  } else if (finalType === "inoculate") {
    translation = {
      id: "fermmanagement.inoculate.run",
      defaultMessage: "Inoculate Run",
    }
    extraKlass = `${extraKlass} inoculate_warning solid-grey-border`
  }
  if (["edit", "inoculate"].includes(finalType)) {
    actionPermitted = actionPermitted && run.status !== "Archiving"
  }
  // - END
  return (
    <>
      {verifyDuplicateModal && (
        <AreYouSureModal
          size={"lg"}
          show={verifyDuplicateModal}
          onHide={(_) => {
            onHide()
            setVerifyDuplicateModal(false)
          }}
          modalBody={
            <div>
              {intl.formatMessage(
                {
                  id: "fermmanagement.confirm.metadata.duplicate.msg",
                  defaultMessage:
                    "This will pre-populate the metadata information from run {run_name} to create a new run. Should we proceed??",
                },
                { run_name: labelSupp },
              )}
            </div>
          }
          submitForm={(_) => {
            setVerifyDuplicateModal(false)
            setRunFormModal(true)
          }}
          cancelForm={(_) => setVerifyDuplicateModal(false)}
        />
      )}
      {runFormModal && (
        <StartRunModal
          show={runFormModal}
          onHide={() => {
            setRunFormModal(false)
            onHide()
          }}
          isUpdate={isUpdate}
          onSuccess={() => {
            setRunFormModal(false)
            onSuccess()
          }}
          run={finalRun}
          intl={intl}
        />
      )}
      <Button
        variant={finalType === "inoculate" ? "" : btnVariant} // Keeping variant empty to allow .inoculate_warning animation
        size={small ? "sm" : ""}
        className={extraKlass}
        style={flexStart ? { alignSelf: "flex-start" } : {}}
        onClick={(e) => {
          e.preventDefault()
          onBtnClick && onBtnClick()
          setModal(true)
        }}
        disabled={disabled || !actionPermitted}
      >
        <span
          className={`fa fa-${glyph}${btnVariant === "primary" && finalType !== "inoculate" ? " text-white" : ""}`}
        />
        &nbsp;&nbsp;
        {intl.formatMessage(translation)}
        {labelSupp && (
          <>
            :<br />
            {labelSupp}
          </>
        )}
      </Button>
    </>
  )
}
